import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Button, DropdownList, Icons } from '@/js/libs/ui/src/V2';

import { SUPPORT_EMAIL } from 'src/constants';

export const SupportButton = memo(function SupportButton() {
  const [t] = useTranslation(['common']);

  const handleMailToSupport = useCallbackRef(() => {
    window.location.href = `mailto:${SUPPORT_EMAIL}`;
  });

  const handleOpenUsersnap = useCallbackRef(() => {
    window.Usersnap?.logEvent('open_usersnap');
  });

  return (
    <DropdownList
      minWidth={false}
      buttonComponent={
        <Button iconOnly ghost data-testid='support-button' title={t('common:SUPPORT')}>
          <Icons.Headphones size={20} />
        </Button>
      }>
      <DropdownList.DropdownItem icon={<Icons.Mail />} onClick={handleMailToSupport} dataTestId='contact-us-button'>
        {t('common:CONTACT_US')}
      </DropdownList.DropdownItem>
      <DropdownList.DropdownItem icon={<Icons.MouseCursor />} onClick={handleOpenUsersnap} dataTestId='usersnap-button'>
        {t('common:USERSNAP')}
      </DropdownList.DropdownItem>
    </DropdownList>
  );
});
